import { render, staticRenderFns } from "./PosInsights.vue?vue&type=template&id=f5fea1c2&scoped=true"
import script from "./PosInsights.vue?vue&type=script&lang=js"
export * from "./PosInsights.vue?vue&type=script&lang=js"
import style0 from "./PosInsights.vue?vue&type=style&index=0&id=f5fea1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fea1c2",
  null
  
)

export default component.exports